/**
 * Which client the console is looking at (BIBLE §19): one client's id, or null for all of
 * them. Every list screen reads it and asks the API for that client's things only.
 *
 * Kept in local storage, unlike the operator key: an operator who works on one client
 * all week should not have to pick it again every morning. Storage that throws (private
 * modes, locked-down browsers) costs only that convenience.
 */

import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

const STORAGE_KEY = 'voe.client'

export interface ClientState {
  selectedClientId: string | null
}

function readStoredClient(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export function persistClient(clientId: string | null): void {
  try {
    if (clientId === null) localStorage.removeItem(STORAGE_KEY)
    else localStorage.setItem(STORAGE_KEY, clientId)
  } catch {
    /* see above */
  }
}

const clientSlice = createSlice({
  name: 'client',
  initialState: (): ClientState => ({ selectedClientId: readStoredClient() }),
  reducers: {
    clientSelected(state, action: PayloadAction<string | null>) {
      state.selectedClientId = action.payload
    },
  },
  selectors: {
    selectClientId: (state) => state.selectedClientId,
  },
})

export const { clientSelected } = clientSlice.actions
export const { selectClientId } = clientSlice.selectors
export default clientSlice.reducer
